import { Box, Skeleton } from '@mui/material';
import { memo } from 'react';
import { embeddedSidebarWidth } from '@/constants/embeddedApplication';

// Mirrors NavigationPanel's dimensions so the sidebar column doesn't shift when real data arrives.
export const EmbeddedNavigationSkeleton = memo(
  function EmbeddedNavigationSkeleton() {
    return (
      <Box
        sx={{
          width: embeddedSidebarWidth,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.paper',
          borderRight: 1,
          borderColor: 'divider',
          p: 1.5,
        }}
      >
        {Array.from({ length: 6 }).map((_, index) => (
          <Skeleton key={index} height={44} sx={{ mb: 1, borderRadius: 1 }} />
        ))}
      </Box>
    );
  },
);
